export const DASHBOARD_CHANGED = 'servicezone:dashboard-changed';

export const notifyDashboardChange = (url, method, response) => {
    if (method === 'get' || !url.startsWith('business/') || response?.status === 'error' || response?.success === false) return;
    window.dispatchEvent(new Event(DASHBOARD_CHANGED));
};
